import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import toWebpImage from '@src/utils/to-webp-image';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

class FifthPageStore extends BaseStore {
  mechaInfo = {
    id: 'falcon',
    bg: toWebpImage(require(`./images/${lang}/kv.png`)),
    role: toWebpImage(require(`./images/${lang}/role.png`)),
    btnDetail: toWebpImage(require(`./images/${lang}/btn-detail.png`))
  };

  use() {
    useMount(() => {});
  }
}
export default FifthPageStore;
